import { HttpService } from '~/helpers';
import { UserService } from '~/services';

const endpoint = 'financeiro/conta_pagar';

const ContaPagarService = {
  getAll: (values, onSuccess, onError) => {
    HttpService.call(endpoint, 'getAll', [{ ...values, cliente: UserService.getUser().codigo }], onSuccess, onError);
  },
  getAllCupomNota: (values, onSuccess, onError) => {
    HttpService.call(endpoint, 'getAllCupomNota', [{ ...values, cliente: UserService.getUser().codigo }], onSuccess, onError);
  },
  getAllCheque: (values, onSuccess, onError) => {
    HttpService.call(endpoint, 'getAllCheque', [{ ...values, cliente: UserService.getUser().codigo }], onSuccess, onError);
  },
  getAllBoleto: (values, onSuccess, onError) => {
    HttpService.call(endpoint, 'getAllBoleto', [{ ...values, cliente: UserService.getUser().codigo }], onSuccess, onError);
  },
  gerarBoleto: (values, onSuccess, onError) => {
    HttpService.call(endpoint, 'gerarBoleto', [{ ...values, cliente: UserService.getUser().codigo }], onSuccess, onError);
  },
  gerarXML: (values, onSuccess, onError) => {
    HttpService.call(endpoint, 'gerarXML', [{ ...values, cliente: UserService.getUser().codigo }], onSuccess, onError);
  },
};

export default ContaPagarService;
